import React, { useState } from 'react';
import s from './s.modules.less';
import { Modal, Spin } from 'antd';
import { Prospect } from 'types/common';
import useGetScriptSureToken from 'hooks/useGetScriptSureToken';
import useGetScriptSurePatientId from 'hooks/useGetScriptSurePatientId';
import { getScriptSureUrl } from 'constants/common';
import commonS from 'styles/common.module.less';
import { TPrescriptionListItem } from 'types/textVisit';

type Props = {
    open?: boolean;
    onClose?: () => void;
    prospect?: TPrescriptionListItem | Prospect;
    prospectId?: number;
};

//https://scriptsure.stoplight.io/docs/scriptsure-api-v3-release/2i5hmd9i5i9zw-widgets#drug-list

const EditPrescribeMedicationModal = ({ open, onClose, prospect, prospectId }: Props) => {
    const [scriptToken, loadingScriptToken, fetchScriptToken] = useGetScriptSureToken(false);
    const [scriptSurePatientId, loadingScriptSurePatientId, fetchScriptSurePatientId] = useGetScriptSurePatientId(prospectId || (prospect as TPrescriptionListItem)?.bpClientId || (prospect as Prospect)?.id);
    const [iframeLink, setIframeLink] = useState<string>('');
    const scriptSureUrl = getScriptSureUrl();

    React.useEffect(() => {
        //URL: https://ssu.scriptsure.com/widgets/drug-history/:patientId?sessiontoken=:sessionToken&appId=:templateId&darkmode=off
        if (scriptToken && scriptSurePatientId) {
            setIframeLink(`${scriptSureUrl}/widgets/drug-history/${scriptSurePatientId}?sessiontoken=${scriptToken.sessionToken}&darkmode=off`);
        }
    }, [scriptToken, scriptSurePatientId, open]);

    React.useEffect(() => {
        if (!open) {
            setIframeLink('');
        } else {
            fetchScriptToken();
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            width={900}
            className={commonS.modalFixHeightWrap}
            title="Edit prescriptions"
            footer={null}
            destroyOnClose
        >
            <div className={s.wrap}>
                {
                    !iframeLink && (
                        <Spin />
                    )
                }
                {
                    iframeLink && (
                        <iframe
                            src={iframeLink}
                            width="100%"
                            height="900px"
                            frameBorder="0"
                            title="Prescribe medication"
                        />
                    )
                }
            </div>
        </Modal>
    );
};

export default EditPrescribeMedicationModal;
